import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/messaging'
import 'firebase/analytics'
// import 'firebaseui/dist/firebaseui.css'
import { GeoFire } from 'geofire'
// firebase init goes here

// DEV //
// const config = {
//   apiKey: 'AIzaSyClBFD7OmQ_rOx-P8u3P9Qz0EcN5SBMf-Q',
//   authDomain: 'jefe-vue.firebaseapp.com',
//   databaseURL: 'https://jefe-vue.firebaseio.com',
//   projectId: 'jefe-vue',
//   storageBucket: 'jefe-vue.appspot.com',
//   messagingSenderId: '498715869648',
//   appId: '1:498715869648:web:93d519d5e88f188e',
//   measurementId: 'G-85ZWWSKH20'
// }

// PROD //
const config = {
  apiKey: 'AIzaSyAp-3_irW2J4zUy_64S2w4kqFioECfBPhg',
  authDomain: 'hefe-tech.firebaseapp.com',
  databaseURL: 'https://hefe-tech.firebaseio.com',
  projectId: 'hefe-tech',
  storageBucket: 'hefe-tech.appspot.com',
  messagingSenderId: '636129052612',
  appId: '1:636129052612:web:338a82fa277934baca0691',
  measurementId: 'G-R3973T6GD6'
}

const app = firebase.initializeApp(config)
// firebase utils
// const db = app.firestore()
const auth = app.auth()
const database = app.database()
const storage = app.storage()
const geoFireRef = database.ref().child('geofire')
const geoFireApp = new GeoFire(geoFireRef)
const analytics = app.analytics()
var messaging = null
var pushToken = null

if (firebase.messaging.isSupported()) {
  messaging = firebase.messaging()
  // DEV //
  // messaging.usePublicVapidKey('BMJ_oGsotFjmNX3MMvVJAD1nicOEl4sbPJdGTf_OM0AHBqLHqlc7VUYShDpNjfuovp3Crf_ZUnBDbY1qtReYNFU')

  // PROD //
  messaging.usePublicVapidKey('BAURX6hz27tVfuF-ao3-7_0KNP4L2mwx66kQwUoCP1gYHcULB0MXXxaj4l_6zQXkqC-hABk_sjMWyQkkfnH6uW4')

  messaging.requestPermission()
    .then(() => messaging.getToken())
    .then((token) => {
      pushToken = token
      // console.log('registered to push')
    })
    .catch(function (err) {
      console.log('Unable to get permission to notify.', err)
    })

  messaging.onMessage(function (payload) {
    console.log('Message received. ', payload)
    // ...
  })
}

// var uiConfig = {
//   signInSuccessUrl: '/dashboard',
//   signInFlow: 'redirect',
//   signInOptions: [
//     // Leave the lines as is for the providers you want to offer your users.
//     firebase.auth.GoogleAuthProvider.PROVIDER_ID,
//     firebase.auth.PhoneAuthProvider.PROVIDER_ID
//   ],
//
//   // tosUrl and privacyPolicyUrl accept either url string or a callback
//   // function.
//   // Terms of service url/callback.
//   tosUrl: '<your-tos-url>',
//   // Privacy policy url/callback.
//   privacyPolicyUrl: function () {
//     window.location.assign('<your-privacy-policy-url>')
//   }
// }

// Initialize the FirebaseUI Widget using Firebase.
// var ui = new firebaseui.auth.AuthUI(auth)
// date issue fix according to firebase
// const settings = {
//   timestampsInSnapshots: true
// }
// db.settings(settings)

// The start method will wait until the DOM is loaded.

// firebase collections
// const usersCollection = db.collection('users')
// // const postsCollection = db.collection('posts')
// // const commentsCollection = db.collection('comments')
// // const likesCollection = db.collection('likes')

export {
  firebase,
  app,
  auth,
  database,
  storage,
  geoFireApp,
  messaging,
  pushToken,
  analytics
}
